// Lodash
import _noop from 'lodash/noop';

// Builders
import ColumnConfig from '../../builders/ColumnConfig';
export var getHeaderPropsForColumn = function getHeaderPropsForColumn() {
  var columnConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new ColumnConfig();
  var data = arguments.length > 1 ? arguments[1] : undefined;
  var getHeaderProps = columnConfig.getGetHeaderProps() || _noop;
  var headerProps = getHeaderProps(data);
  return headerProps;
};